import styled from 'styled-components';

export const LiveCasinoFilterButtonsDefaultBox = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 5;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width:100%;
    margin: 0;
    padding: 1px;
    font-size: 0.725rem;
    border-left: 1px solid ${props => props.theme.colors.boxBorderDark};
    border-right: 1px solid ${props => props.theme.colors.boxBorderDark};

    .sticky-navbar & {
      background: ${props => props.theme.colors.backgroundDark};
    }
  }
`;